import { render, staticRenderFns } from "./WIPKPIChart.vue?vue&type=template&id=7ef066e9&"
import script from "./WIPKPIChart.vue?vue&type=script&lang=js&"
export * from "./WIPKPIChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports